import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { UseMutationResult } from '@tanstack/react-query'
import { COMMUNITY_SECURE_GLOBAL_PREFIX } from 'shared/api/constants/api-constants'
import type { PaginationData } from 'shared/components/pagination'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import type { InvitationInterface } from 'modules/community/types/invitation-interface'
import { communityKeys } from './key-factory'

export const useCancelInvitation = ({
  communityPath,
}: {
  communityPath: string
}): UseMutationResult<void, Error, number> => {
  const queryClient = useQueryClient()
  const { fetcher } = useApiWrapperWithErrorValidation<RequestMethodsEnum.post>({
    method: RequestMethodsEnum.post,
  })

  return useMutation({
    mutationKey: communityKeys.invitations.cancel(communityPath),
    mutationFn: async (invitationId: number) =>
      fetcher(
        `${COMMUNITY_SECURE_GLOBAL_PREFIX}/${communityPath}/invitations/${invitationId}/cancel`,
      ),
    onSuccess: (_data, invitationId) => {
      queryClient.setQueriesData<PaginationData<InvitationInterface[]>>(
        { queryKey: communityKeys.invitations.lists() },
        old => {
          if (!old) return old
          const data = old.data.filter(invitation => invitation.id !== invitationId)
          if (data.length === old.data.length) return old
          return { total: Math.max(0, old.total - 1), data }
        },
      )
      void queryClient.invalidateQueries({ queryKey: communityKeys.invitations.lists() })
    },
    retry: false,
  })
}
